const STATUS_ICON_MAP = {
  active: ['mdi-check-circle-outline', 'green'],
  ready: ['mdi-check-circle-outline', 'green'],
  available: ['mdi-check-circle-outline', 'green'],
  unavailable: ['mdi-alert-circle', 'red'],
  inprogress: ['mdi-cogs', 'red'],
  running: ['mdi-check-circle-outline', 'green'],
  processing: ['mdi-gamepad-circle-up', 'blue'],
  scheduled: ['mdi-clock', 'blue'],
  success: ['mdi-check-circle', 'green'],
  creating: ['mdi-refresh', 'blue'],
  building: ['mdi-upload', 'orange'],
  terminating: ['mdi-cogs', 'grey-darken-1'],
  succeeded: ['mdi-check-circle', 'green'],
  finished: ['mdi-check-circle', 'green'],
  skipped: ['mdi-fast-forward', 'grey'],
  omitted: ['mdi-fast-forward', 'grey'],
  complete: ['mdi-check-circle', 'green'],
  completed: ['mdi-check-circle', 'green'],
  inactive: ['mdi-pause-circle', 'grey-lighten-1'],
  pause: ['mdi-pause-circle', 'grey-lighten-1'],
  paused: ['mdi-pause-circle', 'grey-lighten-1'],
  stopped: ['mdi-stop-circle-outline', 'grey'],
  suspend: ['mdi-pause-circle', 'grey-lighten-1'],
  suspended: ['mdi-pause-circle', 'grey-lighten-1'],
  pending: ['mdi-cogs', 'grey'],
  shared: ['mdi-account-multiple', 'indigo'],
  unshared: ['mdi-account', 'indigo lighten-4'],
  error: ['mdi-alert-circle', 'orange'],
  failed: ['mdi-close-circle-outline', 'red'],
  fail: ['mdi-close-circle-outline', 'red'],
  failure: ['mdi-close-circle-outline', 'red'],
  schedulable: ['mdi-check-circle-outline', 'green'],
  unschedulable: ['mdi-close-circle-outline', 'red'],

  // ML-Vision 업로드 세션 phase / sealStatus
  preparing: ['mdi-cogs', 'grey'],
  uploading: ['mdi-upload', 'blue'],
  discovering: ['mdi-magnify', 'blue'],
  analyzing: ['mdi-cogs', 'blue'],
  finalizing: ['mdi-progress-check', 'blue'],
  sealing: ['mdi-lock-clock', 'orange'],
  sealed: ['mdi-check-circle', 'green'],
  blocked: ['mdi-alert-circle', 'red'],

  // ML-Vision Flow Node saveStatus
  saving: ['mdi-content-save-clock-outline', 'blue'],
  deleting: ['mdi-trash-can-outline', 'orange'],
}

const DEFAULT_ICON = ''
const DEFAULT_COLOR = 'grey-lighten-1'

export const normalizeStatusKey = (status) =>
  String(status || '')
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, '')

const STATUS_TONE_MAP = {
  active: 'success',
  ready: 'success',
  available: 'success',
  running: 'success',
  success: 'success',
  succeeded: 'success',
  finished: 'success',
  complete: 'success',
  completed: 'success',
  healthy: 'success',
  ok: 'success',
  bound: 'success',
  schedulable: 'success',

  pending: 'warning',
  creating: 'warning',
  building: 'warning',
  processing: 'warning',
  starting: 'warning',
  scheduled: 'warning',
  warning: 'warning',

  inprogress: 'info',
  deploying: 'info',
  updating: 'info',
  selected: 'info',
  current: 'info',
  primary: 'info',
  info: 'info',

  stopped: 'neutral',
  stop: 'neutral',
  pause: 'neutral',
  paused: 'neutral',
  suspended: 'neutral',
  suspend: 'neutral',
  inactive: 'neutral',
  skipped: 'neutral',
  omitted: 'neutral',
  unknown: 'neutral',

  danger: 'danger',
  failed: 'danger',
  fail: 'danger',
  failure: 'danger',
  error: 'danger',
  unhealthy: 'danger',
  unavailable: 'danger',
  terminated: 'danger',
  notready: 'danger',
  unschedulable: 'danger',

  // ML-Vision 업로드 세션 phase / sealStatus
  preparing: 'neutral',
  uploading: 'info',
  discovering: 'info',
  analyzing: 'info',
  finalizing: 'info',
  sealing: 'warning',
  sealed: 'success',
  blocked: 'danger',

  // ML-Vision Flow Node saveStatus
  saving: 'info',
  deleting: 'warning',
}

const STATUS_ICON_BY_TONE = {
  success: 'mdi-check-circle-outline',
  warning: 'mdi-alert-circle-outline',
  info: 'mdi-progress-clock',
  neutral: 'mdi-minus-circle-outline',
  danger: 'mdi-close-circle-outline',
}

const normalizeStatus = (status) => normalizeStatusKey(status)

export const getStatusIconValue = (status, type) => {
  const normalized = normalizeStatus(status)
  const matched = STATUS_ICON_MAP[normalized]

  if (!matched) {
    return type === 'type' ? DEFAULT_ICON : DEFAULT_COLOR
  }

  const [icon, color] = matched
  return type === 'type' ? icon : color
}

export const getStatusTone = (status) => {
  const normalized = normalizeStatus(status)
  return STATUS_TONE_MAP[normalized] || 'neutral'
}

export const getStatusMeta = (status) => {
  const tone = getStatusTone(status)
  return {
    tone,
    icon: getStatusIconValue(status, 'type') || STATUS_ICON_BY_TONE[tone] || STATUS_ICON_BY_TONE.neutral,
    color: getStatusIconValue(status, 'color'),
    label: String(status || '').trim(),
  }
}

export const getReplicaStatus = (replicaData, type) => {
  if (type !== 'container') return undefined

  const str = String(replicaData || '').trim()
  if (!str.includes('/')) return undefined

  const activeReplica = Number(str.split('/')[0])
  const totalReplica = Number(str.split('/')[1])

  if (totalReplica === 0) return 'Stopped'
  if (totalReplica > 0 && activeReplica === 0) return 'Pending'
  if (totalReplica > 0 && activeReplica > 0) return 'Running'
  return undefined
}
